import styles from './styles';

import React from 'react';

import { computed } from 'mobx';
import { inject, observer } from 'mobx-react';

import type { WithStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core';

import type HeaderStore from '../../stores/header-store';

interface IProps extends WithStyles<typeof styles>, React.PropsWithChildren {
  headerStore?: HeaderStore;
}

@inject('headerStore')
@observer
class NavContainer extends React.Component<IProps> {
  render() {
    return (
      <div aria-hidden={false} className={this.rootClass} aria-label="navigation menu" role="menu">
        {this.props.children}
      </div>
    );
  }

  @computed
  private get rootClass(): string {
    const { classes, headerStore } = this.props;
    const root = [classes.headerNav];

    if (headerStore!.menuOpen) {
      root.push(classes.open);
    }

    return root.join(' ');
  }
}

export default withStyles(styles)(NavContainer);
